// extracted by mini-css-extract-plugin
export default {"root":"b82Ow"};